import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  label?: string;
  className?: string;
  scrollToCheckout: () => void;
}
export function CtaButton({
  label = 'Quiero definir mis partidos',
  className = '',
  scrollToCheckout
}: CtaButtonProps) {
  return <motion.button type="button" onClick={scrollToCheckout} whileTap={{
    scale: 0.97
  }} whileHover={{
    scale: 1.02
  }} className={`animate-pulse-glow inline-flex w-full items-center justify-center rounded-xl bg-gold px-6 py-4 text-center text-base font-extrabold uppercase tracking-wide text-navy-deep shadow-lg transition-colors hover:bg-[#f0c04f] ${className}`} data-id="element-35">
      {label}
    </motion.button>;
}